module.exports = __webpack_public_path__ + "img/gif.ae228272.svg";